import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '../services/authorization/user.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);
  const tenant = userService.user?.domain;

  const modifiedReq =
    tenant && !req.headers.has('X-Tenant')
      ? req.clone({
          setHeaders: {
            'X-Tenant': tenant
          }
        })
      : req.clone();

  return next(modifiedReq);
};
